import React from "react";

export default function SpinnerOne() {
  return (
    <div className="flex items-center justify-center gap-4 sm:justify-normal">
      <div className="text-gray-200 animate-spin stroke-brand-500 dark:text-gray-800">
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="10"
            cy="10"
            r="8.5"
            stroke="currentColor"
            strokeWidth="3"
          />
          <mask id="path-2-inside-1_3755_26202" fill="white">
            <path d="M18.5172 10C19.3361 10 20.0113 9.33252 19.8903 8.52257C19.6474 6.89692 19.0062 5.34812 18.014 4.01868C16.7246 2.29109 14.9114 1.02642 12.8448 0.413166C10.7781 -0.200084 8.5686 -0.129079 6.54558 0.615599C4.9888 1.18865 3.60659 2.13704 2.51635 3.36711C1.97316 3.97997 2.17495 4.90767 2.86134 5.35436C3.54773 5.80104 4.45707 5.59214 5.03749 5.01442C5.75143 4.3038 6.61392 3.7506 7.57003 3.39866C8.9931 2.87482 10.5473 2.82488 12.0011 3.25626C13.4549 3.68764 14.7303 4.57726 15.6373 5.79251C16.2467 6.609 16.6679 7.5431 16.8787 8.52811C17.05 9.32892 17.6983 10 18.5172 10Z" />
          </mask>
          <path
            d="M18.5172 10C19.3361 10 20.0113 9.33252 19.8903 8.52257C19.6474 6.89692 19.0062 5.34812 18.014 4.01868C16.7246 2.29109 14.9114 1.02642 12.8448 0.413166C10.7781 -0.200084 8.5686 -0.129079 6.54558 0.615599C4.9888 1.18865 3.60659 2.13704 2.51635 3.36711C1.97316 3.97997 2.17495 4.90767 2.86134 5.35436C3.54773 5.80104 4.45707 5.59214 5.03749 5.01442C5.75143 4.3038 6.61392 3.7506 7.57003 3.39866C8.9931 2.87482 10.5473 2.82488 12.0011 3.25626C13.4549 3.68764 14.7303 4.57726 15.6373 5.79251C16.2467 6.609 16.6679 7.5431 16.8787 8.52811C17.05 9.32892 17.6983 10 18.5172 10Z"
            stroke="currentStroke"
            strokeWidth="8"
            mask="url(#path-2-inside-1_3755_26202)"
          />
        </svg>
      </div>

      <div className="text-gray-200 animate-spin stroke-brand-500 dark:text-gray-800">
        <svg
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="14"
            cy="14"
            r="12"
            stroke="currentColor"
            strokeWidth="4"
          />
          <mask id="path-2-inside-1_3755_26205" fill="white">
            <path d="M26.0032 14C27.106 14 28.0146 13.1015 27.8578 12.0099C27.5269 9.70542 26.6246 7.5087 25.2196 5.62615C23.4144 3.20752 20.876 1.43698 17.9827 0.578433C15.0893 -0.280117 11.996 -0.18071 9.16381 0.861838C6.95934 1.67331 5.00491 3.02235 3.47057 4.77332C2.74376 5.60275 3.01525 6.85142 3.93957 7.45295C4.86389 8.05447 6.08878 7.77457 6.86161 6.98784C7.89234 5.93857 9.14776 5.12338 10.5434 4.60965C12.5677 3.8645 14.7786 3.79345 16.8466 4.40709C18.9145 5.02073 20.7288 6.2862 22.0191 8.01488C22.9086 9.20671 23.5162 10.5747 23.8078 12.0164C24.0264 13.0973 24.9004 14 26.0032 14Z" />
          </mask>
          <path
            d="M26.0032 14C27.106 14 28.0146 13.1015 27.8578 12.0099C27.5269 9.70542 26.6246 7.5087 25.2196 5.62615C23.4144 3.20752 20.876 1.43698 17.9827 0.578433C15.0893 -0.280117 11.996 -0.18071 9.16381 0.861838C6.95934 1.67331 5.00491 3.02235 3.47057 4.77332C2.74376 5.60275 3.01525 6.85142 3.93957 7.45295C4.86389 8.05447 6.08878 7.77457 6.86161 6.98784C7.89234 5.93857 9.14776 5.12338 10.5434 4.60965C12.5677 3.8645 14.7786 3.79345 16.8466 4.40709C18.9145 5.02073 20.7288 6.2862 22.0191 8.01488C22.9086 9.20671 23.5162 10.5747 23.8078 12.0164C24.0264 13.0973 24.9004 14 26.0032 14Z"
            stroke="currentStroke"
            strokeWidth="8"
            mask="url(#path-2-inside-1_3755_26205)"
          />
        </svg>
      </div>

      <div className="text-gray-200 animate-spin stroke-brand-500 dark:text-gray-800">
        <svg
          width="36"
          height="36"
          viewBox="0 0 36 36"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="18"
            cy="18"
            r="16"
            stroke="currentColor"
            strokeWidth="4"
          />
          <mask id="path-2-inside-1_3755_26208" fill="white">
            <path d="M34.0036 18C35.1062 18 36.0115 17.1034 35.8894 16.0077C35.5365 12.8389 34.3464 9.80782 32.4252 7.23362C30.1042 4.12395 26.8405 1.84755 23.1206 0.743699C19.4006 -0.360151 15.4235 -0.232341 11.782 1.10808C8.76764 2.21769 6.11686 4.10908 4.09274 6.57246C3.39277 7.42432 3.66248 8.66953 4.58658 9.27092C5.51068 9.8723 6.73753 9.59897 7.46408 8.76966C8.99937 7.01722 10.9552 5.66706 13.1613 4.85499C15.995 3.8119 19.0899 3.71244 21.9847 4.57144C24.8796 5.43043 27.4193 7.20189 29.2254 9.62178C30.6315 11.5057 31.5343 13.7041 31.8653 16.0104C32.0219 17.1017 32.9011 18 34.0036 18Z" />
          </mask>
          <path
            d="M34.0036 18C35.1062 18 36.0115 17.1034 35.8894 16.0077C35.5365 12.8389 34.3464 9.80782 32.4252 7.23362C30.1042 4.12395 26.8405 1.84755 23.1206 0.743699C19.4006 -0.360151 15.4235 -0.232341 11.782 1.10808C8.76764 2.21769 6.11686 4.10908 4.09274 6.57246C3.39277 7.42432 3.66248 8.66953 4.58658 9.27092C5.51068 9.8723 6.73753 9.59897 7.46408 8.76966C8.99937 7.01722 10.9552 5.66706 13.1613 4.85499C15.995 3.8119 19.0899 3.71244 21.9847 4.57144C24.8796 5.43043 27.4193 7.20189 29.2254 9.62178C30.6315 11.5057 31.5343 13.7041 31.8653 16.0104C32.0219 17.1017 32.9011 18 34.0036 18Z"
            stroke="currentStroke"
            strokeWidth="8"
            mask="url(#path-2-inside-1_3755_26208)"
          />
        </svg>
      </div>

      <div className="text-gray-200 animate-spin stroke-brand-500 dark:text-gray-800">
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="20"
            cy="20"
            r="18"
            stroke="currentColor"
            strokeWidth="4"
          />
          <mask id="path-2-inside-1_3755_26211" fill="white">
            <path d="M38.0028 20C39.1058 20 40.0103 19.1036 39.9004 18.0061C39.5397 14.4057 38.2071 10.957 36.0279 8.03735C33.4491 4.58217 29.8228 2.05283 25.6895 0.826332C21.5562 -0.400168 17.1372 -0.258157 13.0912 1.2312C9.67218 2.48973 6.67421 4.65341 4.40811 7.47427C3.71731 8.33418 3.9865 9.57885 4.91099 10.1805C5.83548 10.7821 7.06377 10.5105 7.77579 9.66806C9.55682 7.56082 11.8606 5.94059 14.471 4.97969C17.709 3.78779 21.2454 3.67414 24.5532 4.65568C27.861 5.63723 30.7631 7.66141 32.8269 10.4265C34.4907 12.6557 35.5378 15.2703 35.8812 18.0079C36.0185 19.1024 36.8998 20 38.0028 20Z" />
          </mask>
          <path
            d="M38.0028 20C39.1058 20 40.0103 19.1036 39.9004 18.0061C39.5397 14.4057 38.2071 10.957 36.0279 8.03735C33.4491 4.58217 29.8228 2.05283 25.6895 0.826332C21.5562 -0.400168 17.1372 -0.258157 13.0912 1.2312C9.67218 2.48973 6.67421 4.65341 4.40811 7.47427C3.71731 8.33418 3.9865 9.57885 4.91099 10.1805C5.83548 10.7821 7.06377 10.5105 7.77579 9.66806C9.55682 7.56082 11.8606 5.94059 14.471 4.97969C17.709 3.78779 21.2454 3.67414 24.5532 4.65568C27.861 5.63723 30.7631 7.66141 32.8269 10.4265C34.4907 12.6557 35.5378 15.2703 35.8812 18.0079C36.0185 19.1024 36.8998 20 38.0028 20Z"
            stroke="currentStroke"
            strokeWidth="8"
            mask="url(#path-2-inside-1_3755_26211)"
          />
        </svg>
      </div>

      <div className="text-gray-200 animate-spin stroke-brand-500 dark:text-gray-800">
        <svg
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="24"
            cy="24"
            r="22"
            stroke="currentColor"
            strokeWidth="4"
          />
          <mask id="path-2-inside-1_3755_26214" fill="white">
            <path d="M46.0051 24C47.1068 24 48.0086 23.1053 47.9172 22.0073C47.5452 17.5426 45.9291 13.2565 43.2335 9.64482C40.139 5.4986 35.7874 2.4634 30.8274 0.991599C25.8674 -0.480201 20.5646 -0.309788 15.7094 1.47744C11.4802 3.03423 7.78776 5.74518 5.04079 9.28438C4.36525 10.1547 4.63305 11.3965 5.55649 11.9975C6.47993 12.5984 7.70826 12.3295 8.39813 11.4705C10.6656 8.64692 13.6659 6.48122 17.0877 5.22166C21.1357 3.73155 25.557 3.58947 29.6924 4.81659C33.8278 6.04371 37.456 8.57434 40.0361 12.0313C42.217 14.9533 43.5504 18.405 43.9108 22.0083C44.0205 23.1046 44.9033 24 46.0051 24Z" />
          </mask>
          <path
            d="M46.0051 24C47.1068 24 48.0086 23.1053 47.9172 22.0073C47.5452 17.5426 45.9291 13.2565 43.2335 9.64482C40.139 5.4986 35.7874 2.4634 30.8274 0.991599C25.8674 -0.480201 20.5646 -0.309788 15.7094 1.47744C11.4802 3.03423 7.78776 5.74518 5.04079 9.28438C4.36525 10.1547 4.63305 11.3965 5.55649 11.9975C6.47993 12.5984 7.70826 12.3295 8.39813 11.4705C10.6656 8.64692 13.6659 6.48122 17.0877 5.22166C21.1357 3.73155 25.557 3.58947 29.6924 4.81659C33.8278 6.04371 37.456 8.57434 40.0361 12.0313C42.217 14.9533 43.5504 18.405 43.9108 22.0083C44.0205 23.1046 44.9033 24 46.0051 24Z"
            stroke="currentStroke"
            strokeWidth="8"
            mask="url(#path-2-inside-1_3755_26214)"
          />
        </svg>
      </div>
    </div>
  );
}
